import type { Address } from "viem";

/** Whether the connected wallet may sign an audit for the bytecode repository. */
export function canSignAsAuditor(
  address: Address | undefined,
  auditors: Address[] | undefined,
): boolean {
  if (address === undefined) return false;
  const lower = address.toLowerCase() as Address;
  return (auditors ?? []).some(a => a === lower);
}
